module.exports = __webpack_public_path__ + "img/violet_091.96330e73.png";